<template>
    <div class="w-full h-8 bg-yellow-500" />
</template>
